import { addLayoutResizeListener, removeLayoutResizeListener } from './lib/utils';
export function freezeWindowScroll() {
    Object.assign(document.documentElement.style, {
        overflow: 'hidden',
    });
    Object.assign(document.body.style, {
        overflow: 'visible',
        height: '100%',
    });
}
export function unfreezeWindowScroll() {
    Object.assign(document.documentElement.style, {
        overflow: '',
    });
    Object.assign(document.body.style, {
        overflow: '',
        height: '',
    });
}
let isOpera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
let isChrome = !isOpera && navigator.userAgent.indexOf('Chrome') > -1;
let isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
let isSafari = !isChrome && navigator.userAgent.indexOf("Safari") > -1;
export const browser = Object.freeze({ isOpera, isChrome, isFirefox, isSafari });
const ONE_HOUR_MS = 3600000;
const ONE_WEEK_MS = ONE_HOUR_MS * 24 * 7;
export function formatTime(date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
}
export function formatDate(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    return `${date.getFullYear()}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
}
export function niceDateFromISO8601(dateStr) {
    const then_ms = Date.parse(dateStr);
    const diff_ms = Date.now() - then_ms;
    if (diff_ms < ONE_HOUR_MS) {
        // Within the last hour
        return `${Math.round(diff_ms / 60000)} min sedan`;
    }
    const dtNow = new Date();
    const dtThen = new Date(then_ms);
    if (diff_ms < 48 * ONE_HOUR_MS) {
        if (dtThen.getDay() !== dtNow.getDay()) {
            // Yesterday
            return `Igår ${formatTime(dtThen)}`;
        }
        else if (diff_ms < 6 * ONE_HOUR_MS) {
            // Today, up to 6 hours ago
            return `${Math.round(diff_ms / ONE_HOUR_MS)} timmar sedan`;
        }
        // Today, more than 6 hours ago
        return `Idag ${formatTime(dtThen)}`;
    }
    if (diff_ms < ONE_WEEK_MS) {
        // Within the last week
        return `${Math.round(diff_ms / ONE_HOUR_MS / 24)} dagar sedan`;
    }
    // More than a week ago
    return formatDate(dtThen);
}
// We can't take into account all possible layout shifts and changes outside,
// so let's just check if the height of the inner container has changed from time to time and adjust the height
const heightWatchers = [];
// Have one single interval for all foldables
let heightWatcherInterval = null;
const startHeightWatcherInterval = () => {
    if (heightWatcherInterval) {
        return;
    }
    heightWatcherInterval = window.setInterval(() => {
        for (const watcher of heightWatchers) {
            watcher === null || watcher === void 0 ? void 0 : watcher();
        }
    }, 500);
};
export function makeFoldable(args) {
    if (!args.container.contains(args.innerContainer)) {
        throw new Error('Inner args.container must be a child of the args.container');
    }
    const assignFullHeight = () => {
        if (!isFolded()) {
            args.container.style.height = `${args.innerContainer.scrollHeight}px`;
        }
    };
    const heightWatcherIdx = heightWatchers.length;
    const watchHeight = () => {
        startHeightWatcherInterval();
        if (heightWatchers[heightWatcherIdx]) {
            return;
        }
        let prevInnerHeight = args.innerContainer.scrollHeight;
        heightWatchers[heightWatcherIdx] = () => {
            if (prevInnerHeight !== args.innerContainer.scrollHeight) {
                assignFullHeight();
            }
            prevInnerHeight = args.innerContainer.scrollHeight;
        };
    };
    const stopWatchingHeight = () => {
        heightWatchers[heightWatcherIdx] = null;
    };
    const isFolded = () => args.container.classList.contains('is--folded');
    const fold = () => {
        args.container.style.height = '0';
        args.container.classList.add('is--folded');
        args.clickAreas.forEach(area => {
            area.setAttribute('aria-expanded', 'false');
        });
        stopWatchingHeight();
    };
    const unfold = () => {
        args.container.classList.remove('is--folded');
        args.clickAreas.forEach(area => {
            area.setAttribute('aria-expanded', 'true');
        });
        assignFullHeight();
        watchHeight();
    };
    const toggle = () => isFolded() ? unfold() : fold();
    args.startsFolded ? fold() : unfold();
    args.clickAreas.forEach(area => {
        area.addEventListener('click', toggle);
        area.addEventListener('keydown', (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                toggle();
            }
        });
    });
    addLayoutResizeListener(assignFullHeight);
    const destroy = () => {
        var _a;
        stopWatchingHeight();
        removeLayoutResizeListener(assignFullHeight);
        (_a = args.container.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(args.container);
    };
    return { isFolded, fold, unfold, toggle, destroy };
}
/**
 * This promise will not resolve if Cookiebot is not loaded
 */
//export function waitForCookiebot(): Promise<typeof window.Cookiebot> {
//    return new Promise(async resolve => {
//        let api = null;
//        function checkApi() {
//            if (window.Cookiebot) {
//                api = window.Cookiebot;
//            }
//        }
//        while (!api) {
//            checkApi();
//            await new Promise(r => setTimeout(r, 100));
//        }
//        resolve(api);
//    });
//}
